'use strict';

function ctrl($scope, Global, timeFormat, $http, fetchStream, socketIo, settings, usSpinnerService) {
    $scope.global = Global;

    let model = this;
    model.settings = settings;
    model.complete = false;
    model.lineChartIdentifiers = {
        key: false,
        id: false
    };
    model.servicesIdentifiers = {
        key: false,
        id: false
    };

    socketIo('/api/general_network/services').then(function(socket) {

        /////////////////
        /// LINECHART ///
        /////////////////

        // register data object
        $scope.main.registerVisual({
                refresh: false, // if a number is placed here, it will overwrite the current 1min default
                searchable: true, // optional search param.. no if undefined
                get: {
                    call: 'linechart',
                    socket: socket
                }, // no get default to main url, strings will replace the default (otherwise /[from root])
                grouping: [
                    'hour',
                    'service',
                    'vector',
                    'proto',
                    'resp_country',
                    'resp_hostname',
                    'resp_ip'
                ],
                type: 'linechart',
                settings: {
                    type: 'bandwidth',
                    toggleValues: true,
                    xAxis: '',
                    yAxis: '# MB / Hour'
                },
                searchCategories: {
                    'time': 'Time',
                },
                dimension: function(cfObj) {
                    return cfObj.dimension(function(d) {
                        if ((d.time - d.hour < 3600) && (typeof d.hour === 'string')) {
                            d.hour = Number(d.hour * 1000);
                            return d.hour;
                        }
                    })
                },
                group: function(dimension) { // groups are optional and should default to a reduce if undefined
                    return dimension.group().reduce(
                        function(p, v) {
                            p.bytes_to += v.bytes_orig;
                            p.bytes_from += v.bytes_resp;
                            return p;
                        },
                        function(p, v) {
                            p.bytes_to -= v.bytes_orig;
                            p.bytes_from -= v.bytes_resp;
                            return p;
                        },
                        function() {
                            return {
                                bytes_to: 0,
                                bytes_from: 0
                            };
                        }
                    );
                },
            })
            // fetch the data when the object is registered
            .then(function(result) {
                model.lineChartIdentifiers = {
                        id: result.id,
                        key: result.key
                    }
                    // set dimension & group
                $scope.main.dataObjects[model.lineChartIdentifiers.key].dimension = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.dimension($scope.main.dataObjects[model.lineChartIdentifiers.key].cf);
                $scope.main.dataObjects[model.lineChartIdentifiers.key].group = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.group($scope.main.dataObjects[model.lineChartIdentifiers.key].dimension);
                // return new fetchStream(result.settings.get.call, result.settings.get.socket);
                return new fetchStream(result.settings.get.call, result.settings.get.socket);
            })
            .then(function(result) {
                // stop spinner on complete
                if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched) {
                    usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id)
                }
            }, function(err) {

            }, function(result) {
                $scope.main.dataObjects[model.lineChartIdentifiers.key].cf.add(result.rows);
                if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched) {
                    $scope.$broadcast('init', model.lineChartIdentifiers);
                    // stop spinner on inital data
                    usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id)
                } else {
                    $scope.$broadcast('updatedData', model.lineChartIdentifiers.id, true);
                    $scope.$broadcast('updatedSlider', model.lineChartIdentifiers.id)
                }
            })

        ////////////////
        /// SERVICES ///
        ////////////////

        // register data object
        $scope.main.registerVisual({
                refresh: true, // if a number is placed here, it will overwrite the current 1min default
                searchable: true, // optional search param.. no if undefined
                get: {
                    call: [
                        'outbound',
                        'inbound',
                        'lateral'
                    ],
                    socket: socket
                }, // no get default to main url, strings will replace the default (otherwise /[from root])
                complete: 0,
                grouping: [
                    'service',
                    'proto',
                    'l7_app'
                ],
                type: 'services',
                searchCategories: {
                    'ioc_count' : "IOC Count",
                    'proto': 'Protocol',
                    'service': 'Service',
                    'proto_service': 'Protocol Service',
                    'name': 'Name',
                    'resp_ip': 'Responder IP',
                    'resp_hostname': 'Responder Hostname',
                    'orig_ip': 'Origin IP',
                    'orig_hostname': 'Origin Hostname',
                    'resp_24': 'Subnet 24',
                    'resp_16': 'Subnet 16',
                    'vector': 'Vector',
                    'l7_app': 'l7 Protocol',
                    'resp_country': 'Responder Country',
                    'orig_country': 'Origin Country',
                },
                dimension: function(cfObj) {
                    return cfObj.dimension(function(d) {
                        return (d.proto_service);
                    })
                },
                group: function(dimension) { // groups are optional and should default to a reduce if undefined
                    return dimension.group().reduce(
                        function(p, v) {
                            if (v.orig_ip) {
                                if (!p.clients[v.orig_ip]) {
                                    p.clients[v.orig_ip] = {
                                        name: v.orig_ip + ' (' + v.orig_hostname + ')',
                                        ip: v.orig_ip,
                                        hostname: v.orig_hostname,
                                        resp_24: v.orig_24,
                                        resp_16: v.orig_16,
                                        count: v.count,
                                        ioc_count: v.ioc_count,
                                        bytes_orig: v.bytes_orig,
                                        bytes_resp: v.bytes_resp,
                                        visible: true,
                                        type: 'orig_internal',
                                        total_bytes: (v.bytes_orig + v.bytes_resp),
                                    }
                                } else {
                                    if ((p.clients[v.orig_ip].hostname === 'N/A') && (v.orig_hostname !== 'N/A')) {
                                        p.clients[v.orig_ip].name = v.orig_ip + ' (' + v.orig_hostname + ')'
                                        p.clients[v.orig_ip].hostname = v.orig_hostname
                                    }
                                    p.clients[v.orig_ip].ioc_count += v.ioc_count;
                                    p.clients[v.orig_ip].count += v.count;
                                    p.clients[v.orig_ip].bytes_orig += v.bytes_orig;
                                    p.clients[v.orig_ip].bytes_resp += v.bytes_resp;
                                    p.clients[v.orig_ip].total_bytes += (v.bytes_orig + v.bytes_resp);
                                }
                            } else if (v.orig_country) {
                                if (!p.clients[v.orig_country]) {
                                    p.clients[v.orig_country] = {
                                        name: String(v.orig_cc).toLowerCase(),
                                        name_toggle: v.orig_country,
                                        count: v.count,
                                        ioc_count: v.ioc_count,
                                        bytes_orig: v.bytes_orig,
                                        bytes_resp: v.bytes_resp,
                                        visible: true,
                                        type: 'orig_external',
                                        total_bytes: (v.bytes_orig + v.bytes_resp),
                                    }
                                } else {
                                    p.clients[v.orig_country].ioc_count += v.ioc_count;
                                    p.clients[v.orig_country].count += v.count;
                                    p.clients[v.orig_country].bytes_orig += v.bytes_orig;
                                    p.clients[v.orig_country].bytes_resp += v.bytes_resp;
                                    p.clients[v.orig_country].total_bytes += (v.bytes_orig + v.bytes_resp);
                                }
                            } else if (v.resp_country) {
                                if (!p.servers[v.resp_country]) {
                                    p.servers[v.resp_country] = {
                                        name: String(v.resp_cc).toLowerCase(),
                                        name_toggle: v.resp_country,
                                        count: v.count,
                                        ioc_count: v.ioc_count,
                                        bytes_orig: v.bytes_orig,
                                        bytes_resp: v.bytes_resp,
                                        visible: true,
                                        type: 'external',
                                        total_bytes: (v.bytes_orig + v.bytes_resp),
                                    }
                                } else {
                                    p.servers[v.resp_country].ioc_count += v.ioc_count;
                                    p.servers[v.resp_country].count += v.count;
                                    p.servers[v.resp_country].bytes_orig += v.bytes_orig;
                                    p.servers[v.resp_country].bytes_resp += v.bytes_resp;
                                    p.servers[v.resp_country].total_bytes += (v.bytes_orig + v.bytes_resp);
                                }
                            } else if (v.resp_ip) {
                                if ((!p.servers[v.resp_ip])) {
                                    p.servers[v.resp_ip] = {
                                        name: v.resp_ip + ' (' + v.resp_hostname + ')',
                                        ip: v.resp_ip,
                                        hostname: v.resp_hostname,
                                        resp_24: v.resp_24,
                                        resp_16: v.resp_16,
                                        count: v.count,
                                        ioc_count: v.ioc_count,
                                        bytes_orig: v.bytes_orig,
                                        bytes_resp: v.bytes_resp,
                                        visible: true,
                                        type: 'internal',
                                        total_bytes: (v.bytes_orig + v.bytes_resp),
                                    }
                                } else {
                                    if ((p.servers[v.resp_ip].hostname === 'N/A') && (v.resp_hostname !== 'N/A')) {
                                        p.servers[v.resp_ip].name = v.resp_ip + ' (' + v.resp_hostname + ')'
                                        p.servers[v.resp_ip].hostname = v.resp_hostname
                                    }
                                    p.servers[v.resp_ip].ioc_count += v.ioc_count;
                                    p.servers[v.resp_ip].count += v.count;
                                    p.servers[v.resp_ip].bytes_orig += v.bytes_orig;
                                    p.servers[v.resp_ip].bytes_resp += v.bytes_resp;
                                    p.servers[v.resp_ip].total_bytes += (v.bytes_orig + v.bytes_resp);
                                }
                            }
                            if (v.l7_app) {
                                if (!p.l7_apps[v.l7_app]) {
                                    p.l7_apps[v.l7_app] = {
                                        name: v.l7_app,
                                        count: v.count,
                                        ioc_count: v.ioc_count,
                                        type: 'application',
                                        visible: true,
                                        service: v.service,
                                        proto: v.proto,
                                        clients: {},
                                        servers: {},
                                        bytes_orig: v.bytes_orig,
                                        bytes_resp: v.bytes_resp,
                                        total_bytes: (v.bytes_orig + v.bytes_resp),
                                    }
                                } else {
                                    p.l7_apps[v.l7_app].ioc_count += v.ioc_count;
                                    p.l7_apps[v.l7_app].count += v.count;
                                    p.l7_apps[v.l7_app].bytes_orig += v.bytes_orig;
                                    p.l7_apps[v.l7_app].bytes_resp += v.bytes_resp;
                                    p.l7_apps[v.l7_app].total_bytes += (v.bytes_orig + v.bytes_resp);
                                }
                                if (v.orig_ip) {
                                    if (p.l7_apps[v.l7_app].clients[v.orig_ip]) {
                                        p.l7_apps[v.l7_app].clients[v.orig_ip].ioc_count += v.ioc_count;
                                        p.l7_apps[v.l7_app].clients[v.orig_ip].value += 1;
                                    } else {
                                        p.l7_apps[v.l7_app].clients[v.orig_ip] = {};
                                        p.l7_apps[v.l7_app].clients[v.orig_ip].name = v.orig_ip + ' (' + v.orig_hostname + ')';
                                        p.l7_apps[v.l7_app].clients[v.orig_ip].ioc_count = v.ioc_count;
                                        p.l7_apps[v.l7_app].clients[v.orig_ip].value = 1;
                                    }
                                } else if (v.orig_country) {
                                    if (p.l7_apps[v.l7_app].clients[v.orig_country]) {
                                        p.l7_apps[v.l7_app].clients[v.orig_country].ioc_count += v.ioc_count;
                                        p.l7_apps[v.l7_app].clients[v.orig_country].value += 1;
                                    } else {
                                        p.l7_apps[v.l7_app].clients[v.orig_country] = {};
                                        p.l7_apps[v.l7_app].clients[v.orig_country].name = String(v.orig_cc).toLowerCase();
                                        p.l7_apps[v.l7_app].clients[v.orig_country].ioc_count = v.ioc_count;
                                        p.l7_apps[v.l7_app].clients[v.orig_country].value = 1;
                                    }
                                } else if (v.resp_country) {
                                    if (p.l7_apps[v.l7_app].servers[v.resp_country]) {
                                        p.l7_apps[v.l7_app].servers[v.resp_country].ioc_count += v.ioc_count;
                                        p.l7_apps[v.l7_app].servers[v.resp_country].value += 1;
                                    } else {
                                        p.l7_apps[v.l7_app].servers[v.resp_country] = {};
                                        p.l7_apps[v.l7_app].servers[v.resp_country].name = String(v.resp_cc).toLowerCase();
                                        p.l7_apps[v.l7_app].servers[v.resp_country].ioc_count = v.ioc_count;
                                        p.l7_apps[v.l7_app].servers[v.resp_country].value = 1;
                                    }
                                } else if (v.resp_ip) {
                                    if (p.l7_apps[v.l7_app].servers[v.resp_ip]) {
                                        p.l7_apps[v.l7_app].servers[v.resp_ip].ioc_count += v.ioc_count;
                                        p.l7_apps[v.l7_app].servers[v.resp_ip].value += 1;
                                    } else {
                                        p.l7_apps[v.l7_app].servers[v.resp_ip] = {};
                                        p.l7_apps[v.l7_app].servers[v.resp_ip].ioc_count = v.ioc_count;
                                        p.l7_apps[v.l7_app].servers[v.resp_ip].name = v.resp_ip + ' (' + v.resp_hostname + ')';
                                        p.l7_apps[v.l7_app].servers[v.resp_ip].value = 1;
                                    }
                                }
                            }
                            p.proto = v.proto;
                            p.service = v.service;
                            p.proto_service = v.proto_service;
                            p.name = v.proto_service;
                            p.type = 'services';
                            p.ioc_count += v.ioc_count;
                            p.tot_count += v.count;
                            p.tot_bytes_orig += v.bytes_orig;
                            p.tot_bytes_resp += v.bytes_resp;
                            p.tot_total_bytes += (v.bytes_orig + v.bytes_resp);
                            return p;
                        },
                        function(p, v) {
                            if (v.orig_ip) {
                                if (p.clients[v.orig_ip]) {
                                    p.clients[v.orig_ip].ioc_count -= v.ioc_count;
                                    p.clients[v.orig_ip].count -= v.count;
                                    p.clients[v.orig_ip].bytes_orig -= v.bytes_orig;
                                    p.clients[v.orig_ip].bytes_resp -= v.bytes_resp;
                                    p.clients[v.orig_ip].total_bytes -= (v.bytes_orig + v.bytes_resp);
                                }
                            } else if (v.orig_country) {
                                if (p.clients[v.orig_country]) {
                                    p.clients[v.orig_country].ioc_count -= v.ioc_count;
                                    p.clients[v.orig_country].count -= v.count;
                                    p.clients[v.orig_country].bytes_orig -= v.bytes_orig;
                                    p.clients[v.orig_country].bytes_resp -= v.bytes_resp;
                                    p.clients[v.orig_country].total_bytes -= (v.bytes_orig + v.bytes_resp);
                                }
                            } else if (v.resp_country) {
                                if (p.servers[v.resp_country]) {
                                    p.servers[v.resp_country].ioc_count -= v.ioc_count;
                                    p.servers[v.resp_country].count -= v.count;
                                    p.servers[v.resp_country].bytes_orig -= v.bytes_orig;
                                    p.servers[v.resp_country].bytes_resp -= v.bytes_resp;
                                    p.servers[v.resp_country].total_bytes -= (v.bytes_orig + v.bytes_resp);
                                }
                            } else if (v.resp_ip) {
                                if (p.servers[v.resp_ip]) {
                                    p.servers[v.resp_ip].ioc_count -= v.ioc_count;
                                    p.servers[v.resp_ip].count -= v.count;
                                    p.servers[v.resp_ip].bytes_orig -= v.bytes_orig;
                                    p.servers[v.resp_ip].bytes_resp -= v.bytes_resp;
                                    p.servers[v.resp_ip].total_bytes -= (v.bytes_orig + v.bytes_resp);
                                }
                            }
                            if (v.l7_app) {
                                if (p.l7_apps[v.l7_app]) {
                                    if (v.orig_ip) {
                                        if (p.l7_apps[v.l7_app].clients[v.orig_ip]) {
                                            p.l7_apps[v.l7_app].clients[v.orig_ip].value -= 1;
                                            p.l7_apps[v.l7_app].clients[v.orig_ip].ioc_count -= v.ioc_count;
                                        }
                                    } else if (v.orig_country) {
                                        if (p.l7_apps[v.l7_app].clients[v.orig_country]) {
                                            p.l7_apps[v.l7_app].clients[v.orig_country].value -= 1;
                                            p.l7_apps[v.l7_app].clients[v.orig_country].ioc_count -= v.ioc_count;
                                        }
                                    } else if (v.resp_country) {
                                        if (p.l7_apps[v.l7_app].servers[v.resp_country]) {
                                            p.l7_apps[v.l7_app].servers[v.resp_country].value -= 1;
                                            p.l7_apps[v.l7_app].servers[v.resp_country].ioc_count -= v.ioc_count;
                                        }
                                    } else if (v.resp_ip) {
                                        if (p.l7_apps[v.l7_app].servers[v.resp_ip]) {
                                            p.l7_apps[v.l7_app].servers[v.resp_ip].value -= 1;
                                            p.l7_apps[v.l7_app].servers[v.resp_ip].ioc_count -= v.ioc_count;
                                        }
                                    }
                                    p.l7_apps[v.l7_app].ioc_count -= v.ioc_count;
                                    p.l7_apps[v.l7_app].count -= v.count;
                                    p.l7_apps[v.l7_app].bytes_orig -= v.bytes_orig;
                                    p.l7_apps[v.l7_app].bytes_resp -= v.bytes_resp;
                                    p.l7_apps[v.l7_app].total_bytes -= (v.bytes_orig + v.bytes_resp);
                                }
                            }
                            p.ioc_count -= v.ioc_count;
                            p.tot_count -= v.count;
                            p.tot_bytes_orig -= v.bytes_orig;
                            p.tot_bytes_resp -= v.bytes_resp;
                            p.tot_total_bytes -= (v.bytes_orig + v.bytes_resp);
                            return p;
                        },
                        function() {
                            return {
                                proto: '',
                                service: '',
                                proto_service: '',
                                name: '',
                                visible: true,
                                servers: {},
                                l7_apps: {},
                                clients: {},
                                ioc_count: 0,
                                tot_count: 0,
                                tot_bytes_orig: 0,
                                tot_bytes_resp: 0,
                                tot_total_bytes: 0
                            }
                        }
                    );
                },
            })
            // fetch the data when the object is registered
            .then(function(res) {
                model.servicesIdentifiers = {
                    id: res.id,
                    key: res.key
                }

                let time = angular.copy($scope.main.getTime());
                model.loadStart = time.end
                model.loadEnd = time.end

                $scope.main.dataObjects[model.servicesIdentifiers.key].dimension = $scope.main.dataObjects[model.servicesIdentifiers.key].settings.dimension($scope.main.dataObjects[model.servicesIdentifiers.key].cf);
                $scope.main.dataObjects[model.servicesIdentifiers.key].group = $scope.main.dataObjects[model.servicesIdentifiers.key].settings.group($scope.main.dataObjects[model.servicesIdentifiers.key].dimension);
                for (let i = 0, len = res.settings.get.call.length; i < len; i++) {
                    new fetchStream(res.settings.get.call[i], res.settings.get.socket).then(function(resu) {
                        if ($scope.main.dataObjects[model.servicesIdentifiers.key].group) {
                            $scope.main.dataObjects[model.servicesIdentifiers.key].settings.complete++;
                            if ($scope.main.dataObjects[model.servicesIdentifiers.key].settings.complete >= len) {
                                model.complete = true;
                                usSpinnerService.stop('spinner-' + model.servicesIdentifiers.id)
                            }
                        }
                    }, function(err) {

                    }, function(result) {
                        if ($scope.main.dataObjects[model.servicesIdentifiers.key].group) {
                            $scope.main.dataObjects[model.servicesIdentifiers.key].cf.add(result.rows);
                            if (!$scope.main.dataObjects[model.servicesIdentifiers.key].launched) {
                                $scope.$broadcast('init', model.servicesIdentifiers);
                            } else {
                                $scope.$broadcast('updatedData', model.servicesIdentifiers.id, true);
                            }
                            if (result.min) {
                                model.loadStart = Math.min(model.loadStart, result.min);
                                $scope.$broadcast('updateLoad', model.loadStart);
                            }
                        }
                    })
                }
            })

        $scope.$on('$destroy', function() {
            socket.disconnect();
            model = null;
            socket = null;
        });
    })
};

ctrl.$inject = ['$scope', 'Global', 'timeFormat', '$http', 'fetchStream', 'socketIo', 'settings', 'usSpinnerService'];
module.exports = ctrl;


/** WEBPACK FOOTER **
 ** ./src/pages/controllers/general_network/services.js
 **/